export function getBanks() {
    return [
        { value: 'pkobp', label: 'PKO BP' },
        { value: 'pekao', label: 'Pekao' },
        { value: 'alior', label: 'Alior Bank' },
        { value: 'idea', label: 'Idea Bank' },
        { value: 'getin', label: 'Getin Bank' },
        { value: 'plus', label: 'Plus Bank ' },
        { value: 'bankpocztowy', label: 'Bank Pocztowy' },
        { value: 'bos', label: 'BOŚ Bank ' },
        { value: 'other', label: 'Inny' }
    ];
}

export function getBankAccountCurrencies()
{
    return [
        { value: 'PLN', label: 'PLN' },
        { value: 'EUR', label: 'EUR' },
        { value: 'USD', label: 'USD' },
    ];
};